import { isValidString } from '../common/CommonUtilsMethods';
import { WORKY_WEB_APP_PATHS } from '../WorkyWebAppPaths';

const WORKY_AUTH_EMAIL_QUERY_PARAM: string = 'email';
const PRIMARY_WORKY_CORP_ID_QUERY_PARAM: string = 'primaryWorkyCorpId';

const readWorkyAuthEmailFromLocationSearch = (locationSearch: string): string => {
    const queryParams: URLSearchParams = new URLSearchParams(locationSearch);
    const emailAddress: string | null = queryParams.get(WORKY_AUTH_EMAIL_QUERY_PARAM);
    return isValidString(emailAddress) ? emailAddress.trim().toLowerCase() : '';
};

const readPrimaryWorkyCorpIdFromLocationSearch = (locationSearch: string): string | null => {
    const queryParams: URLSearchParams = new URLSearchParams(locationSearch);
    const primaryWorkyCorpId: string | null = queryParams.get(PRIMARY_WORKY_CORP_ID_QUERY_PARAM);
    if (!isValidString(primaryWorkyCorpId)) {
        return null;
    }
    return primaryWorkyCorpId.trim();
};

const buildWorkyAuthPathWithEmail = (path: string, emailAddress: string): string => {
    const queryParams: URLSearchParams = new URLSearchParams({
        [WORKY_AUTH_EMAIL_QUERY_PARAM]: emailAddress.trim().toLowerCase(),
    });
    return `${path}?${queryParams.toString()}`;
};

const buildWorkySignUpPathWithEmailAndCorpId = (
    emailAddress: string,
    primaryWorkyCorpId: string | null
): string => {
    const queryParams: URLSearchParams = new URLSearchParams();
    if (isValidString(emailAddress)) {
        queryParams.set(WORKY_AUTH_EMAIL_QUERY_PARAM, emailAddress.trim().toLowerCase());
    }
    if (isValidString(primaryWorkyCorpId)) {
        queryParams.set(PRIMARY_WORKY_CORP_ID_QUERY_PARAM, primaryWorkyCorpId.trim());
    }
    const queryString: string = queryParams.toString();
    if (!isValidString(queryString)) {
        return WORKY_WEB_APP_PATHS.signup;
    }
    return `${WORKY_WEB_APP_PATHS.signup}?${queryString}`;
};

export {
    buildWorkyAuthPathWithEmail,
    buildWorkySignUpPathWithEmailAndCorpId,
    readPrimaryWorkyCorpIdFromLocationSearch,
    readWorkyAuthEmailFromLocationSearch,
    PRIMARY_WORKY_CORP_ID_QUERY_PARAM,
    WORKY_AUTH_EMAIL_QUERY_PARAM,
};
